/**
 * Opens an in-app path in a new tab.
 *
 * When this app is embedded as an iframe inside the shell, a relative URL
 * passed to `window.open` resolves against the iframe's own origin (e.g.
 * `legacy.production.ledidi.no`) — not the parent's origin. That sends the
 * user to the standalone legacy host instead of the main shell at
 * `app.ledidi.no`. To avoid this we resolve the trusted parent origin and
 * build an absolute URL pointing at the shell.
 *
 * Falls back to opening the relative path against the current origin when
 * not embedded (e.g. running legacy-frontend standalone in dev) or when the
 * parent origin cannot be trusted.
 */

import { resolveTrustedParentTargetOrigin } from './trusted-parent-origins';

export function openInNewTab(path: string): void {
	const parentOrigin = resolveTrustedParentTargetOrigin();
	const url = parentOrigin ? `${parentOrigin}${path}` : path;
	window.open(url);
}
